<template>
  <div
    v-if="loaded"
    class="competition container">
    <div class="is-pulled-right">
      <nav
        class="breadcrumb"
        aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="/">
              Top
            </router-link>
          </li>
          <li
            :class="{ 'is-active': !day}">
            <router-link :to="'/competition/' + competition.pk">
              {{ competition.name }}
            </router-link>
          </li>
          <li
            v-if="day"
            :class="{ 'is-active': day}">
            <router-link
              to="#"
              aria-current="page">
              {{ day.name }}
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <h1
      v-if="!dayId"
      class="title">
      <translate>Total resultat för</translate>&nbsp;{{ competition.name }}
    </h1>
    <h1
      v-if="day"
      class="title">
      {{ competition.name }} - {{ day.name }}
    </h1>
    <section
      v-if="!live"
      class="section">
      <div
        class="columns">
        <div
          class="column">
          <table class="table">
            <tbody>
              <tr>
                <td><translate>Total vikt</translate>:</td>
                <td>{{ totalWeight.toLocaleString('fi-SV') }} kg</td>
              </tr>
              <tr>
                <td><translate>Totalt Antal Fångster</translate>:</td>
                <td>{{ totalQuantity }}</td>
              </tr>
              <tr>
                <td><translate>Medelvikt</translate>:</td>
                <td>{{ (totalWeight/totalQuantity).toLocaleString('fi-SV') }} kg</td>
              </tr>
              <tr>
                <td><translate>Totalt Antal Lag</translate>:</td>
                <td>{{ totalTeams }}</td>
              </tr>
              <tr>
                <td><translate>Totalt Antal Lag Med Fisk</translate>:</td>
                <td>{{ totalTeamsWithCatch }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="column">
          <nav
            v-if="!dayId"
            class="panel">
            <p class="panel-heading">
              <translate>Tävlingsdagar</translate>
            </p>
            <div
              v-for="(thisday, index) of days"
              :key="index"
              class="panel-block">
              <router-link
                class="button"
                :to="'/competition/' + competition.pk + '/day/' + thisday.pk">
                {{ thisday.name }}
              </router-link>
              <p class="control">
                <router-link
                  class="button is-pulled-right"
                  :to="'/live/' + competition.pk + '/day/' + thisday.pk">
                  Live
                </router-link>
              </p>
            </div>
          </nav>
        </div>
      </div>
    </section>
    <div
      v-if="live"
      class="live">
      <div class="section">
        <div class="columns">
          <div class="column is-three-fifths">
            <result
              :trunc="10"
              :results="results" />
          </div>
          <div class="column catches-column">
            <h2
              v-if="competition"
              class="title">
              <translate>Senaste fångsterna</translate>
            </h2>
            <b-table
              :data="sortedCatches"
              default-sort-direction="desc"
              default-sort="registration_time">
              <template slot-scope="props">
                <b-table-column
                  field="team"
                  :label="$gettext('Lagnummer')">
                  {{ getTeamName(props.row.team, 'number') }}
                </b-table-column>
                <b-table-column
                  field="name"
                  :label="$gettext('Lagnamn')">
                  {{ getTeamName(props.row.team, 'name') }}
                </b-table-column>
                <b-table-column
                  field="country"
                  :label="$gettext('Land')">
                  {{ getTeamCountry(props.row.team) }}
                </b-table-column>
                <b-table-column
                  field="weight"
                  :label="$gettext('Vikt')"
                  numeric>
                  {{ props.row.weight.toLocaleString('fi-SV') }} kg
                </b-table-column>
                <b-table-column
                  field="length"
                  numeric
                  :label="$gettext('Längd')">
                  {{ props.row.length.toLocaleString('fi-SV') }} cm
                </b-table-column>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="columns">
        <div
          v-if="loaded"
          class="column">
          <section>
            <h2
              v-if="dayId"
              class="title">
              <translate>Dagens största</translate>
            </h2>
            <h2
              v-if="!dayId"
              class="title">
              <translate>Tävlingens största</translate>
            </h2>
            <b-table
              :data="biggestCatches"
              default-sort-direction="desc"
              default-sort="weight">
              <template slot-scope="props">
                <b-table-column
                  field="team"
                  :label="$gettext('Lag')">
                  {{ getTeamName(props.row.team) }}
                </b-table-column>
                <b-table-column
                  field="country"
                  :label="$gettext('Land')">
                  {{ getTeamCountry(props.row.team) }}
                </b-table-column>
                <b-table-column
                  field="weight"
                  :label="$gettext('Vikt')"
                  numeric
                  sortable>
                  {{ props.row.weight.toLocaleString('fi-SV') }} kg
                </b-table-column>
                <b-table-column
                  field="length"
                  numeric
                  :label="$gettext('Längd')">
                  {{ props.row.length.toLocaleString('fi-SV') }} cm
                </b-table-column>
              </template>
            </b-table>
          </section>
          <h2
            class="title">
            <translate>Närmast 10 kg</translate>
          </h2>
          <b-table
            :data="closest10"
            default-sort-direction="desc"
            default-sort="weight">
            <template slot-scope="props">
              <b-table-column
                field="team"
                :label="$gettext('Lag')">
                {{ getTeamName(props.row.team) }}
              </b-table-column>
              <b-table-column
                field="country"
                :label="$gettext('Land')">
                {{ getTeamCountry(props.row.team) }}
              </b-table-column>
              <b-table-column
                field="weight"
                :label="$gettext('Vikt')"
                numeric
                sortable>
                {{ props.row.weight.toLocaleString('fi-SV') }} kg
              </b-table-column>
              <b-table-column
                field="length"
                numeric
                :label="$gettext('Längd')">
                {{ props.row.length.toLocaleString('fi-SV') }} cm
              </b-table-column>
            </template>
          </b-table>
        </div>
        <div class="column">
          <h2
            v-if="countryResults"
            class="title">
            <translate>Landskamp</translate>
          </h2>
          <b-table
            :data="countryResults"
            default-sort-direction="desc"
            default-sort="points">
            <template slot-scope="props">
              <b-table-column
                field="position"
                :label="$gettext('Placering')"
                sortable
                width="20"
                numeric>
                {{ props.row.position }}
              </b-table-column>
              <b-table-column
                field="name"
                :label="$gettext('Land')"
                sortable>
                {{ props.row.country }}
              </b-table-column>
              <b-table-column
                field="quantity"
                :label="$gettext('Antal')"
                sortable>
                {{ props.row.quantity }}
              </b-table-column>
              <b-table-column
                field="weight"
                :label="$gettext('Vikt')"
                width="50%"
                numeric
                sortable
                :custom-sort="sortFloat">
                {{ props.row.weight.toLocaleString('fi-SV') }} kg
              </b-table-column>
              <b-table-column
                field="length"
                :label="$gettext('Längd')"
                width="50%"
                numeric
                sortable
                :custom-sort="sortFloat">
                {{ props.row.length.toLocaleString('fi-SV') }} cm
              </b-table-column>
              <b-table-column
                field="points"
                :label="$gettext('Poäng')"
                numeric
                sortable>
                {{ Math.round(props.row.points) }}
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <result
      v-if="!live"
      :results="results" />
    <catches
      v-if="!live"
      :catches="catches" />
  </div>
</template>

<script>
import {
  competitionService, dayService, catchService, teamService, countryService } from '../_services';
import Result from '../components/Result';
import Catches from '../components/Catches';

export default {
  name: 'CompetitionPage',
  components: {
    Result,
    Catches,
  },
  props: {
    id: {
      type: String,
      default: undefined,
    },
    dayId: {
      type: String,
      default: undefined,
    },
    live: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      loaded: false,
      competition: undefined,
      day: undefined,
      days: undefined,
      country: undefined,
      catches: undefined,
      teams: undefined,
      results: [],
      countryResults: [],
      totalWeight: undefined,
      totalQuantity: undefined,
      totalTeams: undefined,
      totalTeamsWithCatch: undefined,
    }
  },
  computed: {
    loggedIn () {
      return this.$store.state.authentication.status.loggedIn;
    },
    user () {
      return this.$store.state.authentication.token
    },
    biggestCatches: function() {
      let copy = this.catches.slice();
      function compare(a, b) {
        if (a.weight > b.weight)
          return -1;
        if (a.weight < b.weight)
          return 1;
        return 0;
      }
      // eslint-disable-next-line
      return copy.sort(compare).slice(0,3);
    },
    closest10: function() {
      let copy = this.catches.slice();
      function compare(a, b) {
        let a_diff = Math.abs(10-a.weight)
        let b_diff = Math.abs(10-b.weight)
        if (a_diff < b_diff)
          return -1;
        if (a_diff > b_diff)
          return 1;
        return 0;
      }
      // eslint-disable-next-line
      return copy.sort(compare).slice(0,1);
    },
    sortedCatches: function() {
      let copy = this.catches.slice();
      function compare(a, b) {
        if (a.registration_time > b.registration_time)
          return -1;
        if (a.registration_time < b.registration_time)
          return 1;
        return 0;
      }
      return copy.sort(compare).slice(0,10);
    },
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetch'
  },
  mounted () {
    var self = this
    self.fetch()

    setInterval(async function () {
      // update data every 1000 ms
      self.fetch()
    }, 10*1000)
  },
  methods: {
    async fetch() {
      var self = this
      try{
        self.competition = await competitionService.get(self.id)
        if (self.dayId){
          self.day = await dayService.get(self.dayId)
          self.catches = await catchService.getAll(self.dayId, null)
        } else {
          self.day = undefined
          self.catches = await catchService.getAll(null, self.id)
        }
        self.teams = await teamService.getAll(self.id)
        self.days = await dayService.getAll(self.id)
        self.country = await countryService.getAll(self.id)
        self.getTeamPoints()
        self.getCountryPoints()
        self.loaded = true
      }catch(err){

        console.error('Caught error')
        console.error(err)
      }
    },
    getTeamPoints: function() {
      var self = this
      self.results = []
      self.totalWeight = 0
      self.totalQuantity = 0
      self.totalTeams = 0
      self.totalTeamsWithCatch = 0
      self.teams.forEach(async function(team){
        var country = self.country.find( ({ pk })  => pk == team.country )

        var quantity = 0
        var weight = 0
        var length = 0
        var points = 0
        var hasCatch = false
        self.catches.forEach(async function(thiscatch){
          if (thiscatch.team == team.pk){
            hasCatch = true
            quantity += 1
            self.totalQuantity +=1
            weight += thiscatch.weight
            self.totalWeight += thiscatch.weight
            length += thiscatch.length
            points += 10 + (thiscatch.weight * 10)
          }
        })
        self.totalTeams += 1
        if (hasCatch){
          self.totalTeamsWithCatch += 1
        }
        self.results.push({
          'number': team.number,
          'name': team.name,
          'country': country.name,
          'quantity': quantity,
          'weight': weight,
          'length': length,
          'points': points,
        })
      })
      self.results.sort(function(a,b){
        if (b.points < a.points) return -1
        if (a.points < b.points) return 1
        if (b.weight < a.weight) return -1
        if (a.weight < b.weight) return 1
        return 0

      })
      self.results.forEach(function(team, index){
        if (team.points > 0){
          team.position = index + 1
        }
      })
    },
    sortFloat: function (a, b, isAsc){
      if (isAsc === true) {
        return a.weight - b.weight
      }
      return b.weight - a.weight
    },
    getTeamName: function(id, attribute='name'){
      var self = this
      try{
        const team = self.teams.find( ({ pk }) => pk == id )
        if (attribute == 'name'){
          return team.name
        }
        if (attribute == 'number'){
          return team.number
        }

      }catch(err){
        return 'Unknown'
      }
    },
    getTeamCountry: function(id){
      var self = this
      try{
        const team = self.teams.find( ({ pk }) => pk == id )
        const country = self.country.find( ({ pk }) => pk == team.country )
        return country.name
      }catch(err){
        return 'Unknown'
      }
    },
    getCountryPoints: function() {
      var self = this
      self.countryResults = []
      self.country.forEach(async function(country){
        let countryResults = self.results.filter(result => result.country == country.name)
        let top2 = countryResults.slice(0,2)
        var quantity = 0
        var weight = 0
        var length = 0
        var points = 0
        var inCompetition = false
        top2.forEach(function(thisresult){
          inCompetition = true
          weight += thisresult.weight
          length += thisresult.length
          points += thisresult.points
        })
        self.catches.forEach(async function(thiscatch){
          const team = self.teams.find( ({ pk }) => pk == thiscatch.team )
          if (team) {
            if (team.country == country.pk){
              quantity += 1
            }
          }
        })
        if (inCompetition){
          self.countryResults.push({
            'country': country.name,
            'quantity': quantity,
            'weight': weight,
            'length': length,
            'points': points,
          })
        }
      })
      self.countryResults.sort(function(a,b){
        if (b.points < a.points) return -1
        if (a.points < b.points) return 1
        if (b.weight < a.weight) return -1
        if (a.weight < b.weight) return 1
        return 0

      })
      self.countryResults.forEach(function(country, index){
        if (country.points > 0){
          country.position = index + 1
        }
      })
    },
  },
}
</script>

<style scoped>
.main-content {
  padding: 30px;
}
.competition {
  font-size: 12px;
}
.title {
  font-size: 1.5em;
}
h1.title {
  margin-bottom: 12px;
}
h2.title {
  padding-top: 10px;
  margin-bottom: 12px;
}
.section {
  padding: 12px;
}
.panel {
  font-size: 1em;
}
.button {
  font-size: 12px;
}
.column:last-child {
  border-left: solid;
  border-left-width: 1px;
  border-left-color: #dddddd;
}
</style>
